!function() {
  "use strict";
  customElements.get("mobile-menu") || customElements.define("mobile-menu", class extends HTMLElement {
    constructor() {
      super(), this.container = this.querySelector("[data-mobile-menu-container]"), this.container && (this.root = this.querySelector("[data-mobile-menu-root]"), 
      this.triggers = this.querySelectorAll("[data-mobile-menu-trigger]"), this.backBtns = this.querySelectorAll("[data-mobile-menu-back]"), 
      this.closeBtns = this.querySelectorAll("[data-close]"), this.init());
    }
    connectedCallback() {
      this.querySelectorAll("[data-mobile-submenu]").forEach((t => {
        t.classList.add("translate-x-full");
      }));
    }
    init() {
      this.triggers.forEach((t => {
        t.addEventListener("click", (e => {
          e.stopPropagation();
          const s = t.getAttribute("data-mobile-menu-trigger");
          this.openSubmenu(s);
        }));
      })), this.backBtns.forEach((t => {
        t.addEventListener("click", (e => {
          e.stopPropagation();
          const s = t.closest("[data-mobile-submenu]");
          s && this.closeSubmenu(s);
        }));
      }));
    }
    openSubmenu(t) {
      const e = this.querySelector(`[data-mobile-submenu="${t}"]`);
      if (e) {
        e.classList.remove("translate-x-full"), this.container.scrollTop = 0, this.container.classList.add("overflow-hidden"), 
        this.container.classList.remove("overflow-y-auto");
        const t = this.querySelector("[data-mobile-menu-root-scroll]");
        t && (t.scrollTop = 0);
        const s = e.querySelector("[data-mobile-menu-submenu-scroll]");
        s && (s.scrollTop = 0);
      }
    }
    closeSubmenu(t) {
      t.classList.add("translate-x-full"), this.root && this.root.classList.remove("hidden"), 
      this.container.classList.remove("overflow-hidden"), this.container.classList.add("overflow-y-auto");
    }
    reset() {
      this.querySelectorAll("[data-mobile-submenu]").forEach((t => {
        t.classList.add("translate-x-full");
      })), this.root && this.root.classList.remove("hidden"), this.container && (this.container.classList.remove("overflow-hidden"), 
      this.container.classList.add("overflow-y-auto"), this.container.scrollTop = 0);
      const t = this.querySelector("[data-mobile-menu-root-scroll]");
      t && (t.scrollTop = 0);
    }
  });
}();